import { useAuth } from '@/hooks/useAuth';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { user } = useAuth(); // ajuste conforme sua lógica de auth

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
